<bb-icon-ui
  name="shopping-cart"
  size="xxl"
  color="primary"
  backgroundType="circle"
></bb-icon-ui>
